var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-/-Morgan-Patrick",
    transform: "translate(-1072.000000, -29.000000)",
    fill: "#03053D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help",
    transform: "translate(1072.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C4.477,20 0,15.523 0,10 C0,4.477 4.477,0 10,0 C15.523,0 20,4.477 20,10 C20,15.523 15.523,20 10,20 Z M10,18 C12.1217,18 14.1566,17.1571 15.6569,15.6569 C17.1571,14.1566 18,12.1217 18,10 C18,7.87827 17.1571,5.84344 15.6569,4.34315 C14.1566,2.84285 12.1217,2 10,2 C7.87827,2 5.84344,2.84285 4.34315,4.34315 C2.84285,5.84344 2,7.87827 2,10 C2,12.1217 2.84285,14.1566 4.34315,15.6569 C5.84344,17.1571 7.87827,18 10,18 Z M9,13 L11,13 L11,15 L9,15 L9,13 Z M11,11.355 L11,12 L9,12 L9,10.5 C9,10.2348 9.10536,9.98043 9.29289,9.79289 C9.48043,9.60536 9.73478,9.5 10,9.5 C10.2841,9.49998 10.5623,9.4193 10.8023,9.26733 C11.0423,9.11536 11.2343,8.89837 11.3558,8.64158 C11.4773,8.3848 11.5234,8.0988 11.4887,7.81684 C11.454,7.53489 11.34,7.26858 11.1598,7.04891 C10.9797,6.82924 10.7409,6.66523 10.4712,6.57597 C10.2015,6.48671 9.91204,6.47587 9.63643,6.54471 C9.36081,6.61354 9.11042,6.75923 8.91437,6.96482 C8.71832,7.1704 8.58468,7.42743 8.529,7.706 L6.567,7.313 C6.68863,6.70508 6.96951,6.14037 7.38092,5.67659 C7.79233,5.2128 8.31952,4.86658 8.90859,4.67332 C9.49766,4.48006 10.1275,4.44669 10.7337,4.57661 C11.3399,4.70654 11.9007,4.99511 12.3588,5.41282 C12.8169,5.83054 13.1559,6.36241 13.3411,6.95406 C13.5263,7.54572 13.5511,8.17594 13.4129,8.78031 C13.2747,9.38467 12.9785,9.9415 12.5545,10.3939 C12.1306,10.8462 11.5941,11.1779 11,11.355 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq);
export default __webpack_public_path__ + "static/media/icon_faq.2bee407e0cc8ac49749f24f74338eef5.svg";
export { ForwardRef as ReactComponent };